module.exports = __webpack_public_path__ + "static/media/loseLarge0_1.562f3bc6.svg";